import httpClient from "Api/httpClient";

const END_POINT = "/units_of_measure";

const getUnitsOfMeasure = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getUnitOfMeasure = (id) => {
    if (!id) return;
    const SINGLE_END_POINT = END_POINT + "/" + id;
    return httpClient.get(SINGLE_END_POINT);
};

const printUnitOfMeasure = (id) => {
    if (!id) return;
    const SINGLE_END_POINT = END_POINT + "/print?id=" + id;
    return httpClient.get(SINGLE_END_POINT);
};

const createUnitsOfMeasure = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateUnitsOfMeasure = (payload, id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteUnitsOfMeasure = (id) => {
    const DELETE_END_POINT = END_POINT + "/" + id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getUnitsOfMeasure, getUnitOfMeasure, printUnitOfMeasure, createUnitsOfMeasure, updateUnitsOfMeasure, deleteUnitsOfMeasure };
